module.exports = __webpack_public_path__ + "static/img/bg1.2b12e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/bg1.png
// module id = EG7h
// module chunks = 1